import { useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { staffApi } from '../api/staff';

export const useDeleteRole = () => {
  const queryClient = useQueryClient();

  const deleteRole = async (roleId: number) => {
    await staffApi.deleteRole(roleId);
    queryClient.invalidateQueries({ queryKey: ['roles'] });
    message.success('Papel excluído com sucesso!');
  };

  return {
    deleteRole,
  };
};
